export const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
export const validateFullName = (name: string) => /^[A-Za-z ]{2,}$/.test(name.trim())
export const validatePan = (pan: string) => /^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(pan)
export const validateAadhar = (aadhar: string) => /^\d{12}$/.test(aadhar.replace(/\s/g, ''))
export const validatePincode = (pincode: string) => /^\d{6}$/.test(pincode)
export const validateIfsc = (ifsc: string) => /^[A-Z]{4}0[A-Z0-9]{6}$/i.test(ifsc)
export const validatePhone = (phone: string) => /^\d{10}$/.test(phone.replace(/\s/g, ''))

export const validateAge18Plus = (dob: string) => {
  if (!dob) return false
  const date = new Date(dob)
  if (isNaN(date.getTime())) return false
  const ageDiff = Date.now() - date.getTime()
  const ageDate = new Date(ageDiff)
  const age = Math.abs(ageDate.getUTCFullYear() - 1970)
  return age >= 18
}

export const maxDobFor18Plus = () => {
  const d = new Date()
  d.setFullYear(d.getFullYear() - 18)
  return d.toISOString().split('T')[0]
}
